import { safeboxClient } from 'myNet'
import { updateToken } from 'services/jwt'

const ROUTE = '/v1/darkweb'

interface ApiResponse<T = any> {
  code: number
  message: string
  data?: T
}

interface ErrorWithCode extends Error {
  code: number
}

interface DarkWebSearchRequest {
  [key: string]: any
}

const DarkWebService = {
  post: async (request: DarkWebSearchRequest): Promise<ApiResponse> => {
    const response = await safeboxClient.post(`${ROUTE}/cl/search`, request, null, null, {})
    const { code, message } = response.data
    if (code !== 200) {
      if (code === 401) {
        updateToken()
          .then(() => {})
          .catch(() => {
            const err = new Error(message) as ErrorWithCode
            err.code = code
            throw err
          })
      } else {
        const err = new Error(message) as ErrorWithCode
        err.code = code
        throw err
      }
    }
    return response.data
  },
}

export default DarkWebService
